<template>
  <div class="login-container">
    <el-form
      autoComplete="on"
      :model="loginForm"
      ref="loginForm"
      label-position="left"
      label-width="0px"
      class="card-box login-form"
    >
      <h3 class="title">
        <i class="logo-icom"><img src="./images/home_logo_img.png" /></i>
        <span class="title-text">综合管理平台</span>

      </h3>
      <el-form-item>
        <el-input
          @keyup.enter.native="handleLogin"
          name="username"
          type="text"
          v-model="loginForm.name"
          autoComplete="on"
          placeholder="登录账号"
        />
      </el-form-item>
      <el-form-item>
        <el-input
          @keyup.enter.native="handleLogin"
          name="password"
          :type="pwdType"
          v-model="loginForm.password"
          maxLength="20"
          autoComplete="on"
          placeholder="输入密码"
        ></el-input>
        <span
          class="show-pwd"
          @click="showPwd"
        >
          <img
            v-if="pwdType === 'password'"
            src="./images/home_mima_nor_icon.png"
          />
          <img
            v-else
            src="./images/home_mima_sel_icon.png"
          />
        </span>
      </el-form-item>
      <el-form-item>
        <el-input
          @keyup.enter.native="handleLogin"
          v-model="loginForm.vcode"
          autoComplete="on"
          placeholder="输入验证码"
          :maxlength="4"
          ref="vcode"
        ></el-input>
        <div class="vcode-box">
          <i class="vcode-img">
            <CodeView :value="verifyCode" /></i>
          <span
            class="vcode-text"
            @click="fetchVcode"
          >换一个</span>
        </div>
      </el-form-item>
      <div class="account-tool">
        <!-- <el-checkbox v-model="remenberAccount">记住账号</el-checkbox> -->
        <!-- <span class="forget-pwd">忘记密码</span> -->
      </div>
      <!-- <el-input ref="paginationExport"></el-input> -->
      <el-button
        class="login-btn"
        type="primary"
        style="width:100%;"
        :loading="loading"
        @click.native.prevent="handleLogin"
      >
        登录
      </el-button>
    </el-form>
    <!-- <span class="com-info">技术支持：028-12231123&nbsp;&nbsp;&nbsp;&nbsp;邮箱地址：renyimen@126.com</span> -->
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { fetchVcode } from '@/api/user/login';
import CodeView from './components/CodeView';
import { passwordValidate } from '../../utils/index';
// import ListMixin from '../../mixins/listPage';
export default {
  name: 'login',
  components: { CodeView },
  // mixins:[ListMixin],
  data() {
    return {
      loginForm: {
        name: '',
        password: '',
        vcode: '',
      },
      loading: false,
      pwdType: 'password',
      verifyCode: '',
      remenberAccount: false,
    };
  },
  created() {
    this.getVcode();
  },
  methods: {
    ...mapActions(['Login']),
    showPwd() {
      if (this.pwdType === 'password') {
        this.pwdType = '';
      } else {
        this.pwdType = 'password';
      }
    },
    validateLoginForm() {
      if (!this.loginForm.name) {
        this.$message.error('请输入账号');
        return;
      }
      if (!this.loginForm.password) {
        this.$message.error('请输入密码');
        return;
      }
      // if (
      //   this.loginForm.password.length < 6 ||
      //   this.loginForm.password.length > 20
      // ) {
      //   this.$message.error('请输入6-20位密码');
      //   return;
      // }
      // if (!passwordValidate(this.loginForm.password)) {
      //   this.$message.error('请输入大小写字母数字符号组合密码');
      //   return;
      // }
      if (!this.loginForm.vcode) {
        this.$message.error('请输入验证码');
        return;
      }
      if (
        this.loginForm.vcode.toUpperCase() !== this.verifyCode.toUpperCase()
      ) {
        this.$message.error('请输入正确验证码');
        this.loginForm.vcode=''
        return;
      }
      return true;
    },
    handleLogin() {
      if (this.validateLoginForm()) {
        this.loading = true;
        this.Login({
          account: this.loginForm.name,
          pwd: this.loginForm.password,
          varifyCode: this.loginForm.vcode,
          remenberAccount: this.remenberAccount,
        })
          .then(res => {
            let userRoles = res.userRoles;
            let userInfo = res.userInfo;
            console.log('login done',userRoles);
            this.loading = false;
            let dashboardPage = userRoles.find(
              item => item.menuCode === process.env.VUE_APP_DASHBOARD_CODE
            );
            if(userInfo.roles.indexOf('SJPTCK')>-1){
              this.$router.push({ path: '/logistics'});
              return;
            }
            if (dashboardPage && this.$router.options.base === '/') {
              this.$router.push({ name: 'dashboard' });
            } else {
              this.$router.push({ path: '/' });
            }
          })
          .catch(err => {
            this.loginForm.vcode = '';
            this.getVcode()
            this.loading = false;
          });
      }
    },
    setToken() {
      if (this.remenberAccount) {
        console.log('记住账号');
      }
    },
    fetchVcode() {
      this.getVcode().then(() => {
        this.loginForm.vcode = '';
        this.$refs.vcode.focus();
      });
    },
    getVcode() {
      return fetchVcode()
        .then(res => {
          console.log(res);
          const { saltKey, verifyCode } = res;
          this.verifyCode = verifyCode;
        })
        .catch(err => {
          this.$message.error('获取验证码失败！');
          console.error(err);
        });
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/styles/variables.scss';
$loginColor: #4e82fb;

.login-container {
  position: fixed;
  height: 100%;
  width: 100%;
  background: #f5f6ff url('./images/home_bg_img.png') no-repeat;
  background-size: contain;
  .login-form {
    position: absolute;
    top: 148px;
    right: 187px;
    width: 494px;
  }
  .title {
    display: flex;
    justify-content: space-between;
    font-size: 34px;
    color: #333;
    font-weight: 600;
    margin: 0 0 54px;
    height: 66px;
    .logo-icom {
      width: 204px;
      height: 66px;
    }
    .title-text {
      line-height: 82px;
    }
  }
  .el-form-item {
    margin-bottom: 16px;
  }
  .show-pwd {
    position: absolute;
    top: 22px;
    right: 26px;
    width: 22px;
    height: 22px;
    cursor: pointer;
  }
  .vcode-box {
    display: flex;
    justify-content: space-between;
    position: absolute;
    top: 18px;
    right: 18px;
    width: 150px;
    line-height: 36px;
    font-size: 14px;
    .vcode-img {
      width: 90px;
    }
    .vcode-text {
      cursor: pointer;
      color: $loginColor;
    }
  }
  .account-tool {
    height: 20px;
    line-height: 20px;
    display: flex;
    justify-content: space-between;
    color: #666;
    .forget-pwd {
      cursor: pointer;
    }
  }
  .login-btn {
    margin-top: 60px;
    height: 66px;
    font-size: 24px;
    background-color: $loginColor;
  }
  input {
    border-color: #666;
    background-color: #fff;
  }
  .el-input,
  .el-input__inner {
    height: 66px;
    line-height: 66px;
    font-size: 20px;
  }
  .com-info {
    position: absolute;
    right: 213px;
    bottom: 40px;
    color: #666;
    font-size: 16px;
  }
}
@media screen and (max-width: $bigScreenWidth) {
  .login-container {
    .login-form {
      top: 125px;
      right: 105px;
      width: 340px;
    }
    .title {
      font-size: 24px;
      margin: 0 0 38px;
      height: 45px;
      .logo-icom {
        width: 140px;
        height: 45px;
      }
      .title-text {
        line-height: 60px;
      }
    }
    .el-form-item {
      margin-bottom: 12px;
    }
    .show-pwd {
      top: 12px;
      right: 16px;
    }
    .vcode-box {
      top: 8px;
      right: 18px;
      width: 120px;
      line-height: 30px;
      font-size: 12px;
      .vcode-img {
        width: 63px;
      }
    }
    .account-tool {
      height: 16px;
      line-height: 16px;
      .el-checkbox__label {
        font-size: 12px;
      }
    }
    .login-btn {
      margin-top: 40px;
      height: 46px;
      font-size: 16px;
    }
    .el-input,
    .el-input__inner {
      height: 46px;
      line-height: 46px;
      font-size: 14px;
    }
    .com-info {
      right: 120px;
      font-size: 10px;
    }
  }
}
</style>
